const logPrefix = "PayCentral: ";
let _cachedVerbose;

function computeVerbose() {
    return (_cachedVerbose = fromQueryString() ?? fromDOM() ?? false);

    function fromQueryString() {
        const usp = new URLSearchParams(document.location.search);
        const urlValue = usp.get("paycentral.sdk.flags.verboseLogging");
        if (urlValue) {
            switch (urlValue.toLowerCase()) {
                case "true":
                    return true;
                case "false":
                    return false;
            }
        }
        return null;
    }

    function fromDOM() {
        const element = document.querySelector(
            "input[type=hidden][id$=SdkVerboseLogging]"
        );
        if (element) {
            switch (element.value.toLowerCase()) {
                case "true":
                    return true;
                case "false":
                    return false;
            }
        }
        return null;
    }
}

function appInsightsTrackTrace(msg, severity, properties) {
    if (!isAppInsightsAvailable()) return;

    try {
        appInsights.trackTrace({ message: msg, severityLevel: severity, properties: properties });
    }
    catch (e) {
        console.warn("Error logging to AppInsights with TrackTrace", e);
    }
}

function isAppInsightsAvailable() {
    return typeof (appInsights) !== "undefined" && appInsights;
}

export const logger = {
    get verboseLogging() {
        return typeof _cachedVerbose === "boolean"
            ? _cachedVerbose
            : computeVerbose();
    },

    logVerboseInfo(msg, properties = null) {
        if (!this.verboseLogging) return;
        const prefixMsg = `${logPrefix}${msg}`;
        appInsightsTrackTrace(prefixMsg, 1 /*SeverityLevel.Information*/, properties);
        if (arguments.length > 1)
            console.info(`${prefixMsg}\n`, properties);
        else
            console.info(prefixMsg);
    },

    logError(msg, properties = null) {
        const prefixMsg = `${logPrefix}${msg}`;
        appInsightsTrackTrace(prefixMsg, 3 /*SeverityLevel.Error*/, properties);
        if (arguments.length > 1)
            console.error(`${prefixMsg}\n`, properties);
        else
            console.error(prefixMsg);
    }
};